import * as z from 'zod';

import { WorkoutPlanId } from '../../../BrandedIds';
import { zodBrandedUuid } from '../../../utils/Zod';
import { BaseLoanEvent } from '../../BaseLoanEvent';

export const CancelForbearanceWorkoutPlanEvent = BaseLoanEvent.extend({
  type: z.literal('cancelForbearanceWorkoutPlan'),
  workoutPlanId: zodBrandedUuid<WorkoutPlanId>(),
});
export type CancelForbearanceWorkoutPlanEvent = z.infer<typeof CancelForbearanceWorkoutPlanEvent>;
